import React from "react";
import { useTranslation } from "react-i18next";

import mundo from "../../img/mundo.png";
import BanderaEsp from "../../img/BanderaEsp.png";
import BanderaUsa from "../../img/BanderaUsa.png";

import "../styleLang.css";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../Redux/Actions/uiActions";

export const Lang = () => {
  const [t, i18n] = useTranslation("global");

  const dispatch = useDispatch();

  const handleSpanish = () => {
    i18n.changeLanguage("es");

    dispatch(setLanguage("spanish"));
  };

  const handleEnglish = () => {
    i18n.changeLanguage("en");
    dispatch(setLanguage("english"));
  };

  return (
    <div className="mx-5 mt-2 py-3">
      <ul className="nav">
        <li className="Li">
          <img loading='lazy' className="icon" src={mundo} alt="Logo Mundo" />
          <ul className="Ul absolute mr-20 mt-5 ring-1 ring-gray-200">
            <li>
              <button className="btn-flag" onClick={handleSpanish}>
                <img loading='lazy' className="flags" src={BanderaEsp} alt="BanderaEsp" />
                <p className="font-medium font-Poppins text-gray-800">
                  {t("spanish")}
                </p>
              </button>
            </li>
            <li>
              <button className="btn-flag" onClick={handleEnglish}>
                <img loading='lazy' className="flags" src={BanderaUsa} alt="BanderaUsa" />
                <p className="font-medium font-Poppins text-gray-800">
                  {t("english")}
                </p>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};
